module.exports = function (fox) {
	"use strict";
	require('./_valentines-popup.styl');
	//require('./stylus/_valentines.styl');
	require('fox-dynamic-injection!fox-template-loader!./templates.tpl')(fox);

	require('./valentinesPopup.js')(fox);
};



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/valentines-gifts-popup/index.js
// module id = 721
// module chunks = 4